import React from "react";
import { Rifm } from 'rifm';
import Question from '../components/Question'
import Address from '../components/Address'
import QuoteStepBase, { getVehicleStepMapDispatch, mapVehicleStepProps } from '../components/QuoteStepBase'
import VehicleTitle from '../components/VehicleTitle'
import { InputGroup, Button, Form, FormControl, Alert } from 'react-bootstrap'
import { IAppState } from "../state/interfaces";
import { IAddress, IAddressChangeResult } from "../classes/Domain";
import { connect } from "react-redux";
import { PATHS, QUOTE_STEPS, YES_NO, COMPONENTS, QUOTE_QUESTIONS } from "../AppConstants";
import QuoteStep from "./QuoteStepLayout";
import Utilities from "../classes/Utilities";
import { IVehicleStepProps, IQuoteStepState } from "../components/interfaces";
import { validationUtils } from "../validation/Validation";
import ReactLoading from 'react-loading';
import ButtonContinue from "../components/ButtonContinue";

const QUESTIONS = {
    MILEAGE: {
        LESS_THAN_FIVE: "< 5",
        FIVE: "5",
        TEN: "10",
        FIFTEEN: "15+",
        //TWENTY: "20",
        //TWENTY_FIVE: "25",
        //THIRTY: "30+",
    }
};

interface IHowYouDriveProps extends IVehicleStepProps {
    vehiclesCount : number
}

interface IState extends IQuoteStepState {
    vehicleUse: string,
    valueMiles: string,
    mileage: string,
    parkAtHome: string,
    garagingAddress: IAddress | null,
    updatingStore: boolean,
    addVehicleClick: boolean,
    continueClick: boolean,
    errors: any;
    invalidGaragingAddress: boolean
}

class HowYouDrive extends QuoteStepBase<IHowYouDriveProps, IState> {
    constructor(props: IHowYouDriveProps) {
        super(props);

        this.next = this.next.bind(this);
        this.onCarAddressChanged = this.onCarAddressChanged.bind(this);

        this.state = {
            vehicleUse: "",
            valueMiles: "",
            mileage: "",
            parkAtHome: "",
            garagingAddress: null,
            updatingStore: false,
            addVehicleClick: false,
            continueClick: false,
            errors: null,
            invalidGaragingAddress: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    subscribeToValidation() {
        validationUtils.subscribeToValidationFailure(this.props.id,
            validationData => {
                this.setState({ ...this.state, updatingStore: false, continueClick: false, addVehicleClick: false, errors: validationData });
            });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const vehicle = nextProps.vehicle;
            const nextState = {
                ...prevState,
                vehicleUse: vehicle.vehicleUse,
                valueMiles: vehicle.valueMiles,
                mileage: vehicle.mileage,
                parkAtHome: vehicle.parkAtHome,
                garagingAddress: QUOTE_QUESTIONS.YES_NO.YES === vehicle.parkAtHome ? null : vehicle.garagingAddress
            };

            nextProps.meta.propsSource = "";
            return nextState;
        }

        return prevState;
    }

    next(event : React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        event.preventDefault();
        if (QUOTE_QUESTIONS.YES_NO.NO === this.state.parkAtHome && null !== this.state.garagingAddress){
            this.setState({ updatingStore: true, continueClick: true, addVehicleClick: false }, () => {
                const updatedVehicle = {
                    ...this.props.vehicle,
                    vehicleUse: this.state.vehicleUse,
                    valueMiles: this.state.valueMiles,
                    mileage: this.state.mileage,
                    parkAtHome: this.state.parkAtHome,
                    garagingAddress: QUOTE_QUESTIONS.YES_NO.YES === this.state.parkAtHome ? {} : this.state.garagingAddress
                };

                this.props.updateAppState({ quoteUid: this.props.quoteUid, vehicle: updatedVehicle })
                    .then(() => this.props.history.push(Utilities.formatUrl(PATHS.ABOUT_YOU, "")),
                        () => {
                            this.setState({ ...this.state, updatingStore: false });
                        });
            });
        }else{
            this.setState({ updatingStore: true, continueClick : true, addVehicleClick : false }, () => {
                const updatedVehicle = {
                    ...this.props.vehicle,
                    vehicleUse: this.state.vehicleUse,
                    valueMiles: this.state.valueMiles,
                    mileage: this.state.mileage,
                    parkAtHome: this.state.parkAtHome,
                    garagingAddress: QUOTE_QUESTIONS.YES_NO.YES === this.state.parkAtHome ? {} : this.state.garagingAddress
                };
    
                this.props.updateAppState({ quoteUid: this.props.quoteUid, vehicle: updatedVehicle })
                    .then(() => this.props.history.push(Utilities.formatUrl(PATHS.ABOUT_YOU, "")),
                        () => {
                            this.setState({ ...this.state, updatingStore: false });
                        });
            });
        }
    }

    callbackFunctionUse = (childData:string) => {
        if (childData === QUOTE_QUESTIONS.VEHICLE_USE.COMMUTING) {
            this.setState({ vehicleUse : childData, valueMiles: "" });
        } else {
            this.setState({ vehicleUse: childData, valueMiles: "8500" });
        }
    };

    callbackFunctionMiles = (childData:string) => {
        switch(childData) {
            case QUESTIONS.MILEAGE.LESS_THAN_FIVE: this.setState({ mileage: childData, valueMiles:"5500"});
                break;
            case QUESTIONS.MILEAGE.FIVE: this.setState({ mileage: childData, valueMiles:"6900"});
                break;
            case QUESTIONS.MILEAGE.TEN: this.setState({ mileage: childData, valueMiles:"9500"});
                break;
            case QUESTIONS.MILEAGE.FIFTEEN: this.setState({ mileage: childData, valueMiles:"11500"});
                break;
            //case QUESTIONS.MILEAGE.TWENTY: this.setState({ mileage: childData, valueMiles:"16100"});
            //    break;
            //case QUESTIONS.MILEAGE.TWENTY_FIVE: this.setState({ mileage: childData, valueMiles:"18500"});
            //    break;
            //case QUESTIONS.MILEAGE.THIRTY: this.setState({ mileage: childData, valueMiles:"20900"});
        }
    };

    callbackFunctionAddress = (childData: string) => {
        this.setState({ parkAtHome: childData });
    };

    onCarAddressChanged(result: IAddressChangeResult) {
        this.setState({
            ...this.state, garagingAddress: result.address, invalidGaragingAddress: !(result.hasOwnProperty("isValid") && result.isValid)
        })
    }

    onAddVehicleClick() {
        if (QUOTE_QUESTIONS.YES_NO.NO === this.state.parkAtHome
            && this.state.garagingAddress
            && Utilities.isAddressFilled(this.state.garagingAddress)) {
            this.setState({ updatingStore: true, continueClick: false, addVehicleClick: true }, () => {
                const updatedVehicle = {
                    ...this.props.vehicle,
                    vehicleUse: this.state.vehicleUse,
                    valueMiles: this.state.valueMiles,
                    mileage: this.state.mileage,
                    parkAtHome: this.state.parkAtHome,
                    garagingAddress: QUOTE_QUESTIONS.YES_NO.YES === this.state.parkAtHome ? {} : this.state.garagingAddress
                };

                this.props.updateAppState({ quoteUid: this.props.quoteUid, vehicle: updatedVehicle })
                    .then(() => this.props.history.push(Utilities.formatUrl(PATHS.VEHICLE_YMM, this.props.vehiclesCount.toString())),
                        () => {
                            this.setState({ ...this.state, updatingStore: false });
                        });
            });
        }else{
            this.setState({ updatingStore: true, continueClick: false, addVehicleClick: true }, () => {
                const updatedVehicle = {
                    ...this.props.vehicle,
                    vehicleUse: this.state.vehicleUse,
                    valueMiles: this.state.valueMiles,
                    mileage: this.state.mileage,
                    parkAtHome: this.state.parkAtHome,
                    garagingAddress: QUOTE_QUESTIONS.YES_NO.YES === this.state.parkAtHome ? {} : this.state.garagingAddress
                };
    
                this.props.updateAppState({ quoteUid: this.props.quoteUid, vehicle: updatedVehicle })
                    .then(() => this.props.history.push(Utilities.formatUrl(PATHS.VEHICLE_YMM, this.props.vehiclesCount.toString())),
                        () => {
                            this.setState({ ...this.state, updatingStore: false });
                        });
            });
        }
    }

    render() {
        return (
            <QuoteStep id={this.props.id}>
                <div className="titleArea"><VehicleTitle vehicle={this.props.vehicle} /></div>

                <Form noValidate className={null != this.state.errors ? "is-invalid" : ""}>
                    <Question
                        name="vehicleUse"
                        selected={this.callbackFunctionUse}
                        selectedValue={this.state.vehicleUse}
                        error={validationUtils.hasValidationErrorFor(this.state.errors, "vehicleUse") ? this.state.errors["vehicleUse"][0] : ""}
                        items={[QUOTE_QUESTIONS.VEHICLE_USE.COMMUTING, /*QUOTE_QUESTIONS.VEHICLE_USE.PERSONAL,*/ QUOTE_QUESTIONS.VEHICLE_USE.BUISNESS/*, QUOTE_QUESTIONS.VEHICLE_USE.FARMING, QUOTE_QUESTIONS.VEHICLE_USE.OTHER*/]}
                        lable="What is this car's primary use?" />

                    <Question
                        name="mileage"
                        error={validationUtils.hasValidationErrorFor(this.state.errors, "mileage") ? this.state.errors["mileage"][0] : ""}
                        style={{ display: this.state.vehicleUse === QUOTE_QUESTIONS.VEHICLE_USE.COMMUTING ? '' : 'none' }}
                        selected={this.callbackFunctionMiles}
                        selectedValue={this.state.mileage}
                        items={[QUESTIONS.MILEAGE.LESS_THAN_FIVE, QUESTIONS.MILEAGE.FIVE, QUESTIONS.MILEAGE.TEN, QUESTIONS.MILEAGE.FIFTEEN, /*QUESTIONS.MILEAGE.TWENTY, QUESTIONS.MILEAGE.TWENTY_FIVE, QUESTIONS.MILEAGE.THIRTY*/]}
                        lable="About how many miles each way?" />

                    <Form.Label>Annual mileage</Form.Label>

                    <Rifm
                        accept={/\d/g}
                        format={Utilities.formatNumber}
                        value={this.state.valueMiles}
                        onChange={(v: any) => { this.setStateValue(v.toString().replace(/[^\d]/gi, ""), "valueMiles") }}>
                        {({ value, onChange }) => (
                            <InputGroup className="mb-3">
                                <FormControl
                                    placeholder="ex. 12,000"
                                    aria-describedby="basic-addon2"
                                    onChange={onChange}
                                    value={value}
                                    className={null != this.state.errors ? (validationUtils.hasValidationErrorFor(this.state.errors, "valueMiles") ? "is-invalid" : "is-valid") : ""}
                                    pattern="[0-9]*"
                                    inputmode="numeric"
                                />
                                <InputGroup.Append>
                                    <InputGroup.Text id="basic-addon2">miles</InputGroup.Text>
                                </InputGroup.Append>
                            </InputGroup>
                        )}
                    </Rifm>

                    {validationUtils.hasValidationErrorFor(this.state.errors, "valueMiles")
                        ? <Form.Control.Feedback type="invalid">
                            {this.state.errors["valueMiles"][0]}
                        </Form.Control.Feedback>
                        : null
                    }

                    <Question
                        name="parkAtHome"
                        selected={this.callbackFunctionAddress}
                        error={validationUtils.hasValidationErrorFor(this.state.errors, "parkAtHome") ? this.state.errors["parkAtHome"][0] : ""}
                        selectedValue={this.state.parkAtHome}
                        items={[QUOTE_QUESTIONS.YES_NO.YES, QUOTE_QUESTIONS.YES_NO.NO]}
                        lable="Do you park this car at your home address?" />

                    <Address
                        errors={validationUtils.extractErrorsByPrefix(this.state.errors, "garagingAddress.")}
                        label="Where do you keep your car?"
                        value={this.state.garagingAddress}
                        style={{ display: YES_NO.NO === this.state.parkAtHome ? '' : 'none' }}
                        onChange={this.onCarAddressChanged} />
                </Form>

                <div className="btnContainer">
                    <Button
                        className="btnAddVehicle"
                        onClick={() => { this.onAddVehicleClick() }}
                        disabled={this.state.updatingStore || this.state.invalidGaragingAddress}>{this.state.updatingStore && this.state.addVehicleClick ? <ReactLoading type={"spin"} className="continue-loading" color={"#389BFF"} height={'20px'} width={'20px'} /> : <i className="fas fa-plus"></i>} Add another car</Button>
                    <div className="orText"><p>or</p></div>
                    <ButtonContinue
                        disabled={this.state.updatingStore || this.state.invalidGaragingAddress}
                        showLoading={this.state.updatingStore && this.state.continueClick}
                        onClick={this.next} />
                </div>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IVehicleStepProps) => {
    var props = mapVehicleStepProps(state, ownProps);
    props["vehiclesCount"] = state.vehicles.length;

    return props;
}

export default connect(mapProps, getVehicleStepMapDispatch(QUOTE_STEPS.HOW_YOU_DRIVE))(HowYouDrive);
